import { Injectable } from '@angular/core';
import {RaffleCategoryMetadata} from '@core/models/raffle.model';
import {RootPathCheckerService as RootPathCheckerServiceBase} from '@core/services/root-path-checker/root-path-checker.service';

@Injectable({
  providedIn: 'root'
})
export class RootPathCheckerService extends RootPathCheckerServiceBase {

  getRaffleCategoryMetadataList(): RaffleCategoryMetadata[] {
    return [
      this.getCompetitionsMetadata('All Competitions', 'all-competitions', null, 'gray', true, true, true),
      this.getCompetitionsMetadata('Today’s Competitions!', 'todays-competitions', 'today', 'gray'),
      this.getCompetitionsMetadata('Tomorrow’s Competitions!', 'tomorrows-competitions', 'tomorrow', 'gray'),
      this.getCompetitionsMetadata('Just Launched', 'just-launched', 'launched', 'gray'),
      this.getCompetitionsMetadata('Monday Draws', 'monday-draws', 'monday', 'gray'),
      this.getCompetitionsMetadata('Tuesday Draws', 'tuesday-draws', 'tuesday', 'gray'),
      this.getCompetitionsMetadata('Wednesday Draws', 'wednesday-draws', 'wednesday', 'gray'),
      this.getCompetitionsMetadata('Thursday Draws', 'thursday-draws', 'thursday', 'gray'),
      this.getCompetitionsMetadata('Friday Draws', 'friday-draws', 'friday', 'gray'),
      this.getCompetitionsMetadata('Saturday Draws', 'saturday-draws', 'saturday', 'gray'),
      this.getCompetitionsMetadata('Sunday Draws', 'sunday-draws', 'sunday', 'gray'),
      this.getCompetitionsMetadata('Christmas Draws', 'christmas-draws', '2022-12-25', 'gray'),
      this.getCompetitionsMetadata('New Years Day Competitions', 'newyear-draws', '2022-01-01', 'gray'),
    ];
  }

}
